var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitcherLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25031 2.32915V1.3629C8.25031 1.27915 8.15406 1.2329 8.08906 1.28415L2.45406 5.6854C2.40618 5.72263 2.36744 5.77031 2.34079 5.82479C2.31415 5.87927 2.30029 5.93912 2.30029 5.99977C2.30029 6.06042 2.31415 6.12027 2.34079 6.17476C2.36744 6.22924 2.40618 6.27691 2.45406 6.31415L8.08906 10.7154C8.15531 10.7666 8.25031 10.7204 8.25031 10.6366V9.6704C8.25031 9.60915 8.22156 9.5504 8.17406 9.5129L3.67406 6.0004L8.17406 2.48665C8.22156 2.44915 8.25031 2.3904 8.25031 2.32915Z",
    fill: "black",
    fillOpacity: 0.45
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcherLeft);
export default __webpack_public_path__ + "static/media/switcher-left.e8b6fb3c734c231fa9bd70fafa7e279a.svg";
export { ForwardRef as ReactComponent };